import { Route, Routes, useLocation } from "react-router-dom";

import OldRoutes from "./OldRoutes";

const NewRoutes = ({
  navigateWorkspace,
  actualpage,
  userData,
  orgData,
  workspaceData,
  masterData,
}) => {
  return (
    <Routes>
      <Route
        path="*"
        element={
          <OldRoutes
            path_prefix="/workspace/:id"
            navigateWorkspace={navigateWorkspace}
            userData={userData}
            orgData={orgData}
            workspaceData={workspaceData}
            masterData={masterData}
          ></OldRoutes>
        }
      />
    </Routes>
  );
};

export default NewRoutes;
